import React, { useEffect } from 'react';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';
import './NotificationUI.css'
const NotificationUI = (props: UIProperties<NotificationUIConfig>) => {
	var timeout: any = null;
	useEffect(() => {
		if(!timeout) {
			timeout = setTimeout(() => {
				props.parameters.onDismissed();
			}, 5000);
		}
	}, [])
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '1422px',
			width: '300px',
			height: '152px'
		}} >
			<img style={{
				width: '100%'
			}} src="./assets/images/notification/window_modal_1.png" />
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '100%'
			}} tabIndex={0} id="notification-root" dangerouslySetInnerHTML={{ __html: props.parameters.text }}>

			</div>
		</div>
	);

};

export interface NotificationUIConfig extends BaseConfig{
	text: string;
	onDismissed?: () => void;
}

export default NotificationUI;